import { render } from "./step4.vue?vue&type=template&id=c011c504&scoped=true"
import script from "./step4.vue?vue&type=script&lang=ts"
export * from "./step4.vue?vue&type=script&lang=ts"

import "./step4.vue?vue&type=style&index=0&id=c011c504&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c011c504"

export default script